import Image from 'next/image';
import Link from 'next/link';
import { DealRating } from '~/components/product';
import { DealReview } from '~/types/deal';

import ExternalLinkIcon from '~/public/font-awesome/external-link-alt_bolt.png';

interface IProductDetailRating {
  dealReview: DealReview;
  reviewUrl?: string;
  PDPUrl: string;
  showDealRatings?: boolean;
  showProductLink?: boolean;
  className?: string;
}

function ProductDetailRating({
  dealReview,
  reviewUrl,
  PDPUrl,
  showDealRatings,
  className,
  showProductLink = true,
}: IProductDetailRating) {
  return (
    <div
      className={`flex flex-wrap items-center gap-2 text-sm ${className ?? ''}`}
    >
      {showDealRatings && (
        <DealRating
          averageRating={dealReview.average_rating}
          reviewCount={dealReview.review_count}
          href={reviewUrl ?? PDPUrl}
          // isAggregatePage
          size="sm"
        />
      )}
      {showDealRatings && showProductLink && (
        <span className="text-gray-400">&#124;</span>
      )}
      {showProductLink && (
        <Link
          href={PDPUrl}
          target="_blank"
          className="flex items-center text-blue-600 hover:underline"
        >
          Product details
          <Image
            src={ExternalLinkIcon}
            alt="external link icon"
            height={54}
            width={48}
            className="ml-2 h-4 w-4"
          />
        </Link>
      )}
    </div>
  );
}

export default ProductDetailRating;
